module.exports = __webpack_public_path__ + "static/media/photo2@2x.91ec3b3d.jpg";